import { MessageCircle } from 'lucide-react'

import { usePermission } from '@/lib/permissions'

interface SupportChatTriggerProps {
  onClick: () => void
}

export function SupportChatTrigger({ onClick }: SupportChatTriggerProps) {
  const canUseSupportChat = usePermission('can_use_support_chat')
  if (!canUseSupportChat) return null

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label="Open support chat"
      className="fixed bottom-6 right-6 z-40 flex items-center gap-2 rounded-full bg-blue-600 px-4 py-3 text-sm font-medium text-white shadow-lg transition-colors hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 dark:focus:ring-offset-neutral-900"
    >
      <MessageCircle className="h-5 w-5" />
      <span className="hidden sm:inline">Chat</span>
    </button>
  )
}
